import { optimizedImgixUrl } from '@uswitch/comms-ui.image'
import React from 'react'

import * as st from '../styles'
import { usePageContext } from '~/contexts/page-context'
import { HERO_IMAGE } from '~/utils/journey-image-paths'

import P0Container from './container'

export const P0 = ({ address, p0, postcode, currentProvider, headerImage, hideImageWhilstLoading }) => {
  const { questionLedJourney } = usePageContext()

  return (
    <>
      {p0 && <P0Container p0={p0} currentProvider={currentProvider} postcode={postcode} address={address} />}
      {!hideImageWhilstLoading && !p0 && headerImage?.url && (
        <picture sx={st.hideOnMobile}>
          <source srcSet='data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=' media='(max-width: 767px)' />
          <img
            src={optimizedImgixUrl(questionLedJourney ? HERO_IMAGE : headerImage && headerImage.url)}
            sx={st.heroImgStyle}
            alt=''
          />
        </picture>
      )}
    </>
  )
}
